import styled from 'styled-components';
import {
    MobileWidgetGradientCardNameIconStyled
} from '../../MobileWidgets/MobileWidgetGradientCardsNameIcon/styled/MobileWidgetGradientCardsNameIconStyled';

export const MobileRecommendedStyled = styled.div`
    position: relative;

    .arrow-left, .arrow-right {
        position: absolute;
        bottom: -14px;
    }

    .arrow-left {
        left: 0;
    }

    .arrow-right {
        right: 0;
    }
`;

export const MobileRecommendedScrollStyled = styled.div`
    display: flex;
    gap: 8px;
    overflow-x: scroll;
    padding-bottom: 22px;

    &.mobile {
        padding: 0 16px;
        margin: 0 -16px;
    }

    > ${MobileWidgetGradientCardNameIconStyled} {
        flex-shrink: 0;
        flex-grow: 0;
    }
`;